<template>
  <footer class="footer-v2">
    <div class="footer-inner">
      <div class="footer-top">
        <div class="footer-brand">
          <img :src="logoSrc" :alt="siteConfig.siteName || 'logo'" />
          <p>{{ displaySiteName }}</p>
        </div>
        <div class="footer-links">
          <div class="link-group">
            <h4>{{ $t('footer.quickLinks') }}</h4>
            <router-link to="/">{{ $t('common.home') }}</router-link>
            <router-link to="/about">{{ $t('common.about') }}</router-link>
            <router-link to="/news">{{ $t('common.news') }}</router-link>
            <router-link to="/cases">{{ $t('common.cases') }}</router-link>
          </div>
          <div class="link-group">
            <h4>{{ $t('footer.serviceAreas') }}</h4>
            <router-link to="/cases/debug">{{ $t('footer.debug') }}</router-link>
            <router-link to="/cases/operation">{{ $t('footer.operation') }}</router-link>
            <router-link to="/contact">{{ $t('footer.consulting') }}</router-link>
          </div>
          <div class="link-group">
            <h4>{{ $t('common.contact') }}</h4>
            <p>{{ $t('common.address') }}：{{ displayAddress }}</p>
            <p>{{ $t('common.phone') }}：{{ siteConfig.serviceTel || '0531-76786345' }}</p>
            <p>{{ $t('common.email') }}：{{ siteConfig.email || 'cseesbl@163.com' }}</p>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>{{ copyrightText }} <a href="https://beian.miit.gov.cn/" target="_blank">{{ siteConfig.icp || defaultIcp }}</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
import { getSiteConfig } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultLogo from '@/assets/images/senbole-logo-mark.png'

export default {
  name: 'FooterV2',
  data() {
    return {
      siteConfig: {},
      defaultIcp: '鲁ICP备2026028132号-1',
      defaultAddress: '山东省济南市莱芜高新区汇源大街67号高创中心833室',
      defaultEnglishAddress: 'Room 833, Gaochuang Center, No. 67 Huiyuan Street, Laiwu High-tech Zone, Jinan, Shandong'
    }
  },
  computed: {
    logoSrc() {
      return resolveFileUrl(this.siteConfig.logoUrl, defaultLogo)
    },
    displaySiteName() {
      return this.$langState.locale === 'en'
        ? 'Shandong Senbole Power Engineering Co., Ltd.'
        : (this.siteConfig.siteName || '山东盛博莱电力工程有限公司')
    },
    displayAddress() {
      return this.$langState.locale === 'en'
        ? this.defaultEnglishAddress
        : (this.siteConfig.address || this.defaultAddress)
    },
    copyrightText() {
      if (this.siteConfig.copyright && this.$langState.locale === 'zh') {
        return this.siteConfig.copyright
      }
      return `${this.$t('footer.copyrightPrefix')}: ${this.displaySiteName}`
    }
  },
  created() {
    getSiteConfig().then(data => {
      this.siteConfig = data || {}
    }).catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
.footer-v2 {
  background: #0b1120;
  color: rgba(255,255,255,0.6);
  margin-top: auto;
}

.footer-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px 30px 30px;
}

.footer-top {
  display: flex;
  gap: 80px;
  margin-bottom: 50px;
}

.footer-brand {
  width: 280px;
  flex-shrink: 0;

  img {
    width: 58px;
    height: 58px;
    object-fit: contain;
    border-radius: 12px;
    margin-bottom: 20px;
    box-shadow: 0 8px 24px rgba(239, 0, 18, 0.24);
  }

  p {
    font-size: 16px;
    color: rgba(255,255,255,0.8);
  }
}

.footer-links {
  flex: 1;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}

.link-group {
  h4 {
    font-size: 16px;
    color: #fff;
    margin-bottom: 20px;
    font-weight: 600;
  }

  a, p {
    display: block;
    font-size: 14px;
    color: rgba(255,255,255,0.5);
    line-height: 2.2;
    transition: color 0.3s;
  }

  a:hover {
    color: #3b82f6;
  }
}

.footer-bottom {
  border-top: 1px solid rgba(255,255,255,0.1);
  padding-top: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 13px;
    color: rgba(255,255,255,0.4);

    a {
      color: rgba(255,255,255,0.4);
    }
  }
}

@media (max-width: 960px) {
  .footer-top {
    flex-direction: column;
    gap: 40px;
  }

  .footer-links {
    flex-wrap: wrap;
  }
}
</style>
